
import service from '../services/request'

// 提交建议
export const insertAdvice = function (data) {
  return service({
    method: 'post',
    url: '/advice/insertAdvice',
    data
  })
}